import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import CTASection from './components/CTASection';
import PortfolioSectionA from './components/PortfolioSectionA';
import ServicesShowcaseSection from '../portfolio/components/ServicesShowcaseSection';
import ToolsSection from '../../components/feature/ToolsSection';
import ValuePropositionSection from './components/ValuePropositionSection';
import HeroSectionVideo from './components/HeroSectionVideo';

export default function Home() {
  return (
    <div className="min-h-screen bg-white dark:bg-slate-900 transition-colors duration-300">
      <Header />
      <main>
        <HeroSectionVideo />
        <ServicesShowcaseSection />
        <ToolsSection />
        <PortfolioSectionA />
        <ValuePropositionSection />
        <CTASection />
      </main>
      <Footer />
    </div>
  );
}
